window.BOLD = window.BOLD || {};
BOLD.BMS = BOLD.BMS || {};
/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery._jscookie = function (b, j, m) {
  if (typeof j != 'undefined') {
    m = m || {};
    if (j === null) {
      j = '';
      m.expires = -1;
    }
    let e = '';
    if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
      let f;
      if (typeof m.expires == 'number') {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = '; expires=' + f.toUTCString();
    }
    const l = m.path ? '; path=' + m.path : '';
    const g = m.domain ? '; domain=' + m.domain : '';
    const a = m.secure ? '; secure' : '';
    document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
  } else {
    let d = null;
    if (document.cookie && document.cookie != '') {
      const k = document.cookie.split(';');
      for (let h = 0; h < k.length; h++) {
        const c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + '=') {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

Handlebars.registerHelper('formatMoney', function (price) {
  return Shopify.formatMoney(price, window.money_format);
});
Handlebars.registerHelper('getCurrencyIso', function () {
  return Shopify && Shopify.currency ? Shopify.currency.active : '';
});

BOLD.BMS.RecentProducts = (function ($) {
  let compiledTemplate;
  const config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    onCompconste: null
  };

  let productHandleQueue = [];
  let products = [];
  let shown = 0;

  const cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      $._jscookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function () {
      let recentlyViewed = [];
      const cookieValue = $._jscookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(/[ ]+/);
      }
      return recentlyViewed;
    },
    destroy: function () {
      $._jscookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      const position = $.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  const fetchAndRender = function () {
    const currentPageProductHandle = window.location.pathname.match(
      /\/products\/([a-z0-9\-]+)/
    )[1];
    if (
      productHandleQueue[0] === currentPageProductHandle ||
      (products.length && productHandleQueue[0] === products[0].handle)
    ) {
      productHandleQueue.shift();
      return fetchAndRender();
    }
    if (productHandleQueue.length && shown < config.howManyToShow) {
      return axios
        .get('/products/' + productHandleQueue[0] + '.js')
        .then(function (data) {
          const product = data.data;

          // Add waitlist promo tag if the product has the 'waitlist' tag
          if (product.tags.includes('waitlist')) {
            const waitlistTag = getGlobalPromoTag('waitlist');
            if (waitlistTag) {
              product.waitlistPromoTag = getPromoTagMarkup(waitlistTag);
            }
          }

          const saleEnabled = product.tags.includes(window.saleEnabledTag);
          if (window.isSaleEnabled && saleEnabled) {
            if (!product.compare_at_price) {
              product.compare_at_price = product.price;
            }
            product.price = calculateSalePrice(product.price);
          }
          products.push(product);
        })
        .then(function () {
          productHandleQueue.shift();
          shown++;
          return fetchAndRender();
        })
        .catch(function (error) {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          console.error(error);
          return fetchAndRender();
        });
    } else {
      return render();
    }
  };

  function getGlobalPromoTag(relatedTag) {
    let globalPromoTags;
    try {
      globalPromoTags = JSON.parse(
        document.getElementById('promo-tag-manager-json').innerHTML
      ).promoTags;
    } catch (e) {
      console.warn("Can't set promoTags.");
      return null;
    }

    return globalPromoTags.find(tag => tag.relatedTag === relatedTag);
  }

  function getPromoTagMarkup(promoTag) {
    return `<div
      class="promo-tag"
      style="color: ${promoTag.textColor}; background-color: ${promoTag.backgroundColor};"
    >
      ${promoTag.label}
    </div>`;
  }

  const render = function () {
    if (products.length) {
      const recentProductsHtml = compiledTemplate({ products: products });
      $('#product-recent').html(recentProductsHtml);
    } else {
      $('#product-recent').parent().remove();
    }
    recordRecentlyViewed();

    if (window.innerWidth > 500 && window.innerWidth < 1025)
      justifyMobileGrid();
  };

  const recordRecentlyViewed = function () {
    // Read cookie.
    let recentlyViewed = cookie.read();

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {
      // What is the product handle on this page.
      const productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];
      // In what position is that product in memory.
      const position = $.inArray(productHandle, recentlyViewed);
      // If not in memory.
      if (position === -1) {
        // Add product at the start of the list.
        recentlyViewed.unshift(productHandle);
        // Only keep what we need.
        recentlyViewed = recentlyViewed.splice(
          0,
          config.howManyToStoreInMemory
        );
      } else {
        // Remove the product and place it at start of list.
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      // Update cookie.
      cookie.write(recentlyViewed);
    }
  };

  const justifyMobileGrid = function () {
    const $mobileGrid = document.querySelector('.js-bold-rec-grid');
    const $title = document.querySelector('.js-bold-rec-title');
    if (!$mobileGrid) return;
    if ($mobileGrid?.children?.length < 3) {
      $mobileGrid.style.justifyContent = 'center';
      $title.style.textAlign = 'center';
    } else {
      $mobileGrid.style.justifyContent = 'unset';
      $title.style.textAlign = 'left';
    }
  };

  function init(template, onComplete) {
    compiledTemplate = Handlebars.compile(template);
    productHandleQueue = cookie.read();
    fetchAndRender();
  }

  function calculateSalePrice(price) {
    const percentageOff = window.saleDiscountPercentage;
    const discount = 1 - percentageOff / 100;
    return price * discount;
  }

  return {
    init: init,
    recordRecentlyViewed: recordRecentlyViewed
  };
})(BOLD.$ || $);
